import { Dictionary } from "@/lib/Dictionary.type";
import ObjectBuilderInterface from "@/modules/api/object-builder.interface";
import ApiCollectionResponseParserService from "@/modules/api/api-collection-response-parser.service";
import ApiService from "@/modules/api/api.service";
import BasicRepository from "@/modules/api/basic.repository";
import { FieldOrderDesc } from "@/modules/api/field-order-options";

import Attachment from "./attachment.model";

export default class AttachmentRepository extends BasicRepository<Attachment> {
  constructor(
    api: ApiService,
    objectBuilder: ObjectBuilderInterface<Attachment>,
    responseParser: ApiCollectionResponseParserService<Attachment>
  ) {
    super("attachments", api, objectBuilder, responseParser);
  }

  public async createAttachment(
    messageId: string,
    storageItemId: string,
    mime: string
  ): Promise<Attachment> {
    const data: Dictionary<string> = {
      messageId: messageId,
      storageItemId: storageItemId,
      mime,
    };

    const response = await this.api.post(this.resourceName, data);

    return this.objectBuilder.buildFromJSON(response.data);
  }

  public async getByMessageIds(messageIds: string[]): Promise<Attachment[]> {
    return this.fetchChunkedByFilter({ message: messageIds }, "message", [
      ["createdAt", FieldOrderDesc],
    ]);
  }
}
